import React from 'react';

const Support = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            242 Network Support
          </h1>
          <p className="text-xl text-gray-600">
            We're here to help you with any questions or issues
          </p>
        </div>

        {/* Contact Information */}
        <div className="bg-white shadow-md rounded-lg p-8 mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-6">
            Contact Us
          </h2>
          
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                General Support
              </h3>
              <p className="text-gray-600 mb-2">
                For general questions and technical support:
              </p>
              <a 
                href="mailto:support@242network.com"
                className="text-primary-600 hover:text-primary-700 font-medium"
              >
                support@242network.com
              </a>
            </div>

            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Application Issues
              </h3>
              <p className="text-gray-600 mb-2">
                If you're experiencing issues with your application:
              </p>
              <a 
                href="mailto:info@242network.com"
                className="text-primary-600 hover:text-primary-700 font-medium"
              >
                info@242network.com
              </a>
            </div>

            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Phone Support
              </h3>
              <p className="text-gray-600 mb-2">
                Call us during business hours (Central Time):
              </p>
              <p className="text-gray-900 font-medium">
                Monday - Friday: 9:00 AM - 5:00 PM
              </p>
            </div>
          </div>
        </div>

        {/* FAQ Section */}
        <div className="bg-white shadow-md rounded-lg p-8 mb-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-6">
            Frequently Asked Questions
          </h2>
          
          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                How do I apply to become a church planter?
              </h3>
              <p className="text-gray-600">
                You can start the application process through our online portal. 
                Complete the pre-assessment form, and our team will review your 
                submission and guide you through the next steps.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                I forgot my password. How do I reset it?
              </h3>
              <p className="text-gray-600">
                Click the "Forgot Password" link on the login page. Enter your 
                email address, and we'll send you instructions to reset your password.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                How can I check the status of my application?
              </h3>
              <p className="text-gray-600">
                Log in to your portal account to view your application status 
                and track your progress through the onboarding process.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Who can I contact about the assessment process?
              </h3>
              <p className="text-gray-600">
                Your assigned hub leader will be your primary point of contact 
                throughout the assessment process. You can also reach out to 
                our support team at{' '}
                <a 
                  href="mailto:info@242network.com"
                  className="text-primary-600 hover:text-primary-700"
                >
                  info@242network.com
                </a>
              </p>
            </div>

            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                What technical requirements are needed for the mobile app?
              </h3>
              <p className="text-gray-600">
                The 242 Network mobile app requires iOS 14.0 or later for iPhone 
                and iPad devices. Make sure you have a stable internet connection 
                for the best experience.
              </p>
            </div>
          </div>
        </div>

        {/* App Information */}
        <div className="bg-white shadow-md rounded-lg p-8">
          <h2 className="text-2xl font-semibold text-gray-900 mb-6">
            Mobile App Support
          </h2>
          
          <div className="space-y-4">
            <p className="text-gray-600">
              The 242 Network mobile app is designed specifically for hub leaders 
              to manage church planters and onboarding candidates on the go.
            </p>
            
            <div>
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                App Features:
              </h3>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>View and manage church planters</li>
                <li>Track onboarding candidates</li>
                <li>Add and review contact history</li>
                <li>Monitor training progress</li>
                <li>Receive important notifications</li>
                <li>Access dashboard statistics</li>
              </ul>
            </div>

            <div className="mt-6">
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                Troubleshooting Tips:
              </h3>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Ensure you're running the latest version of the app</li>
                <li>Check your internet connection</li>
                <li>Try logging out and logging back in</li>
                <li>Restart the app if it becomes unresponsive</li>
                <li>Contact support if issues persist</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-12">
          <p className="text-gray-600">
            Need immediate assistance?{' '}
            <a 
              href="mailto:support@242network.com"
              className="text-primary-600 hover:text-primary-700 font-medium"
            >
              Contact our support team
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Support;



